import { validTimezones } from "@aidkitorg/types/lib/survey";
export const isValidDateFormat = (dateStr) => {
    if (!dateStr)
        return false;
    return /^\d{4}-\d{2}-\d{2}$/.test(dateStr);
};
export const isValidTimeFormat = (timeStr) => {
    if (!timeStr)
        return false;
    return /^\d{2}:\d{2}$/.test(timeStr);
};
export const buildDateInTimezone = (dateStr, timeStr, timezone) => {
    const [year, month, day] = dateStr.split('-').map(Number);
    const [hours, minutes] = timeStr.split(':').map(Number);
    if (timezone === 'UTC') {
        return new Date(Date.UTC(year, month - 1, day, hours, minutes, 0, 0));
    }
    const formatter = new Intl.DateTimeFormat('en-US', {
        timeZone: timezone,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false,
    });
    const utcGuess = new Date(Date.UTC(year, month - 1, day, hours, minutes, 0, 0));
    const parts = formatter.formatToParts(utcGuess);
    const getPart = (type) => parts.find(p => p.type === type)?.value || '0';
    const tzYear = Number(getPart('year'));
    const tzMonth = Number(getPart('month'));
    const tzDay = Number(getPart('day'));
    const tzHour = Number(getPart('hour'));
    const tzMinute = Number(getPart('minute'));
    const utcMs = Date.UTC(year, month - 1, day, hours, minutes, 0, 0);
    const tzMs = Date.UTC(tzYear, tzMonth - 1, tzDay, tzHour, tzMinute, 0, 0);
    const offsetMs = tzMs - utcMs;
    return new Date(utcMs - offsetMs);
};
export const validateDateTimeInputs = (dateStr, timeStr, timezone) => {
    if (!isValidDateFormat(dateStr)) {
        return null;
    }
    if (!isValidTimeFormat(timeStr)) {
        return null;
    }
    const date = buildDateInTimezone(dateStr, timeStr, timezone);
    if (isNaN(date.getTime())) {
        return null;
    }
    return date;
};
export const getBrowserTimezone = () => {
    const browserTz = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const matchingTz = validTimezones.find(tz => tz === browserTz);
    return matchingTz || 'UTC';
};
export const getCurrentDateTimeValues = (timezone) => {
    const tz = timezone ?? getBrowserTimezone();
    const now = new Date();
    const formatter = new Intl.DateTimeFormat('en-US', {
        timeZone: tz,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false,
    });
    const parts = formatter.formatToParts(now);
    const getPart = (type) => parts.find(p => p.type === type)?.value || '00';
    return {
        date: `${getPart('year')}-${getPart('month')}-${getPart('day')}`,
        time: `${getPart('hour')}:${getPart('minute')}`,
        timezone: tz,
    };
};
